import styled from 'styled-components'

export const TaskInput = styled.input`
    outline: none;
    border: none;
    border-bottom: 1px solid #000;
    margin-top: 10px;
`